import * as React from 'react';
import styled from 'styled-components';
import { Route, Routes } from 'react-router-dom';
import { FlexBox, IBaseComponentProps, StackPanel } from '@agilepoint/wat-react-ux';
import { LoadingIllustration } from 'common';
import { NavigationMenuBase } from './navigation-base-menu';
import { Logo } from './logo';
import { NavBarFooter } from './nav-bar-footer';
import { NotFoundPage } from '../pages/not-found-page';
import { CopyRight } from 'common/copyright-info';
import { useConfigScopeSelectors } from '../scopes';
import { DownloadBuildPage } from '../../my-apps/components/download-build/download-build-page';

export interface ICoreAppLayoutProps extends IBaseComponentProps<HTMLDivElement> {
    routes: React.ReactNode[];
}

const PrimaryContentArea = styled.div`
    height: calc(100% - 30px);
    /* overflow-y: auto; */
`;

const NavMenuBlock = styled(FlexBox) <{ $isMenuCollapsed: boolean }>`
    height: 100%;
    width: ${({ $isMenuCollapsed }) => ($isMenuCollapsed ? '60px' : '270px')};
    box-sizing: border-box;
    padding: 10px 0px ${({ $isMenuCollapsed }) => ($isMenuCollapsed ? '25px' : '20px')} 0px;
    background-color: ${props => props.theme.semantics.palette.white};

    .ap-treeView-wrapper {
        width: 100% !important;
        border: none;
        .ap-collapsibleMenu-itemWrapper {
            padding: 10px ${({ $isMenuCollapsed }) => ($isMenuCollapsed ? '12px' : '8px')};
        }
        .ap-treeView-item span {
            max-width: 150px;
        }
    }
`;

const NavResult = styled(StackPanel) <{ $isMenuCollapsed: boolean }>`
    height: 100%;
    width: ${({ $isMenuCollapsed }) => ($isMenuCollapsed ? 'calc(100% - 60px)' : 'calc(100% - 270px)')};
    background-color: ${({ theme: { mobileAppAccelerator } }) => mobileAppAccelerator.semanticColors.pageBackgroundColor};
`;

const ContentArea = styled.div`
    height: 100%;
    overflow-y: auto;
    /* flex-grow: 1; */
    width: 100%;
`;

export const CoreAppLayoutBase = React.memo((props: ICoreAppLayoutProps) => {
    const { routes, className } = props;
    const [isMenuCollapsed, toggleMenu] = React.useState(false);
    const { selectMobileAppAcceleratorConfig } = useConfigScopeSelectors();
    const { copyrightYear } = selectMobileAppAcceleratorConfig();

    const onModeChange = React.useCallback(() => {
        toggleMenu(!isMenuCollapsed);
    }, [toggleMenu, isMenuCollapsed]);

    return (
        <FlexBox className={className} justifyContent="row" alignItems="center">
            <NavMenuBlock $isMenuCollapsed={isMenuCollapsed} flexDirection="column" alignItems="center">
                <Logo isMenuCollapsed={isMenuCollapsed} />
                <NavigationMenuBase onModeChange={onModeChange} cursorType="pointer" />
                <NavBarFooter isMenuCollapsed={isMenuCollapsed} />
            </NavMenuBlock>
            <NavResult $isMenuCollapsed={isMenuCollapsed}>
                <ContentArea className='core-app-content-area'>
                    <PrimaryContentArea>
                        <React.Suspense fallback={<LoadingIllustration />}>
                            <Routes>
                                {routes}
                                <Route path='/download' element={<DownloadBuildPage />} />
                                <Route key="not-found-page" path='*' element={<NotFoundPage />} />
                            </Routes>
                        </React.Suspense>
                    </PrimaryContentArea>
                    <CopyRight year={copyrightYear} />
                </ContentArea>
            </NavResult>
        </FlexBox>
    );
});
